import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import Color from 'src/assets/_util.scss';
import LoadingSpinner from 'src/components/core/LoadingSpinner/LoadingSpinner';
import { HSpacer } from 'src/components/core/Spacer';
import { HStack, VStack } from 'src/components/core/Stack';
import { Button } from 'src/components/Insights/Common/Button';
import CreateCatalogDialog from 'src/components/Insights/Dialogs/CreateCatalogDialog';
import useDialogState from 'src/components/Insights/utils/dialog';
import Layout from 'src/components/Layout/Layout';
import { selectors as authSelectors } from 'src/redux/auth/auth-selectors';
import { selectors as insightsSelectors } from 'src/redux/insights/insights-selectors';
import { loadCatalogs } from 'src/redux/insights/insights-slice';
import CatalogCard from './CatalogCard';
import { organizeCatalogs } from './utils';

const CatalogsPage = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const catalogs = useSelector(insightsSelectors.getCatalogs);
  const isLoading = useSelector(insightsSelectors.isLoading);
  const organizations = useSelector(authSelectors.getOrganizations);
  const organizedCatalogs = organizeCatalogs(catalogs, organizations);
  const [dialogState, openDialog, closeDialog] = useDialogState();

  React.useEffect(() => {
    dispatch(loadCatalogs());
  }, [dispatch]);

  return (
    <Layout
      className="CatalogsRoute"
      title={t('main_nav.insights')}
      contentStyle={{
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        paddingBottom: 0,
      }}
    >
      <HStack
        sx={{
          pb: '17px',
          borderBottom: `1px solid ${Color.gray400}`,
          alignItems: 'center',
        }}
      >
        <h1 className="h2 lh-1 mb-0">{t('main_nav.insights')}</h1>
        <HSpacer grow />
        <Button onClick={openDialog('newCatalog')} sx={{ p: '8px 16px' }}>
          {t('insights.newCatalog')}
        </Button>
      </HStack>

      <VStack
        sx={{ gap: 2, overflow: 'auto', height: '100%', p: '16px 8px 32px' }}
      >
        {isLoading ? (
          <div className="w-100 text-center mt-4">
            <LoadingSpinner active size="lg" />
          </div>
        ) : (
          organizedCatalogs.map(([organization, catalogs], index) => (
            <VStack key={index} sx={{ gap: 2, mb: 5 }}>
              <h3 className="mb-0">{organization.name}</h3>

              {catalogs.map((catalog) => (
                <CatalogCard catalog={catalog} key={`catalog/${catalog.id}`} />
              ))}
            </VStack>
          ))
        )}
      </VStack>

      <CreateCatalogDialog
        closeDialog={closeDialog('newCatalog')}
        open={Boolean(dialogState['newCatalog'])}
      />
    </Layout>
  );
};

export default CatalogsPage;
